import { render, staticRenderFns } from "./PaymentPSE.vue?vue&type=template&id=c9f8ab20&"
import script from "./PaymentPSE.vue?vue&type=script&lang=js&"
export * from "./PaymentPSE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports